import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemRadioButtonSelected = function IconSystemRadioButtonSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "var(--stroke-color, currentColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--fill-color, currentColor)",
    d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  }));
};